import * as BusinessManagerAPI from '@wix/business-manager-api';
import { appDefIds } from '@wix/business-manager-api';

export const getInstanceForAuthorization = () => BusinessManagerAPI.getCurrentInstance(appDefIds.consentPolicyBanner);

export const getMetaSiteInstanceForAuthorization = () => BusinessManagerAPI.getCurrentInstance(appDefIds.metaSite);

export const refreshInstance = async (appDefId: string = appDefIds.consentPolicyBanner) => {
  return BusinessManagerAPI.refreshInstance(appDefId);
};

export const getConsentPolicyInstanceId = async (): Promise<string> => {
  let currentInstance = BusinessManagerAPI.getCurrentInstance(appDefIds.consentPolicyBanner);
  if (!currentInstance) {
    currentInstance = await refreshInstance();
  }
  if (!currentInstance) {
    return Promise.reject('failed to retrieve instanceId');
  }
  return JSON.parse(atob(currentInstance.split('.').pop() || '')).instanceId;
};
